/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { IAccordionItemViewProps } from '@msdyn365-commerce-modules/accordion/dist/types/modules/accordion-item/accordion-item';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';

const AccordionItemView: React.FC<IAccordionItemViewProps> = props => {

        const { drawer, accordionSlots, AccordionItemContainer, AccordionItemContent } = props;
        const element = document.getElementById(props.AccordionItemContainer.moduleProps.id);
        const childElement = element?.getElementsByClassName('ms-accordion-item-content');
        let hideAccordion = '';
        if (childElement && childElement[0] && childElement[0].childElementCount === 0) {
            hideAccordion = 'accordion-item-hide';
        }
        return (
            <Module {...AccordionItemContainer} id={props.AccordionItemContainer.moduleProps.id} className={classnames(AccordionItemContainer.className, hideAccordion)}>
                <Node {...drawer}>
                    <Node {...AccordionItemContent}>
                        {accordionSlots && accordionSlots.accordionItemContent && accordionSlots.accordionItemContent.length && (_renderAccordionItemContent(accordionSlots.accordionItemContent))}
                    </Node>
                </Node>
            </Module>
        );
    };

const _renderAccordionItemContent = (items: React.ReactNode[]): JSX.Element | null => {
    return (
        <>
            {items && items.length ? (
             items.map((item: React.ReactNode, index: number) => {
                 return (
                     <React.Fragment key={index}>
                         {item}
                     </React.Fragment>
                 );
             })
         ) : null}
        </>
    );
};
export default AccordionItemView;